import axios from "../../plugins/axios";

export const state = {
    filtros: null,
}

export const mutations = {
    SET_FILTROS(state, filtros) {
        state.filtros = filtros;
    },
}

export const getters = {
    getFiltros(state) {
        return state.filtros;
    },
}

export const actions = {
    listarTestesConformidade(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('testes-conformidade/' + payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    ataulizarTestesConformidade(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('testes-conformidade/' + payload.id, payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/testesConformidade.js